import React from 'react';
import ReactDOMServer from 'react-dom/server';

function CustomMarkerIcon(props){
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 57">
			<defs>
				<style>{ `
				.cls-1 {fill: #fff;}
				.cls-2 {fill: #e7e7e7;}
				.color-01 {fill: #8E1230;}
				.color-02 {fill: #E9573D;}
				.color-03 {fill: #3cb44b;}
				.color-04 {fill: #4363d8;}
				.color-05 {fill: #911eb4;}
				.color-06 {fill: #f99e32;}
				.color-07 {fill: #ff0052;}
				.color-08 {fill: #006238;}
				.color-09 {fill: #161670;}
				.color-10 {fill: #f032e6;}
				.color-11 {fill: #9a6324;}
				.color-12 {fill: #808000;}
				.color-13 {fill: #009eff;}
				.color-14 {fill: #9c87ea;}
				.color-15 {fill: #704b4d;}
				.color-16 {fill: #469990;}
				.color-17 {fill: #004955;}
				.color-18 {fill: #5c6791;}
				.color-19 {fill: #ccb450;}
				.color-20 {fill: #83b713;}
				.color-21 {fill: #ff9cff;}
				.color-22 {fill: #447753;}
				` }</style>
			</defs>
			{ props.macroCatC == 'CIELO TERRA' &&
			<g id="base-ct" className={`color-${props._colorId || '01'}`}>
				<polygon class="cls-2" points="8.48 51 0 51 0 14.48 12.5 5.78 25 14.48 25 51 16.52 51 12.5 56.74 8.48 51" />
        		<polygon points="12.5 7 1 15 1 50 9 50 12.5 55 16 50 24 50 24 15 12.5 7" />
			</g>
			}
			{ props.macroCatC == 'PORZIONI' &&
			<g id="base-porz" className={`color-${props._colorId || '01'}`}>
				<polygon class="cls-2" points="8.48 51 0 51 0 5.09 12.5 13.78 25 5.09 25 51 16.52 51 12.5 56.74 8.48 51" />
        		<polygon points="12.5 15 1 7 1 50 9 50 12.5 55 16 50 24 50 24 7 12.5 15" />


			</g>
			}
			{ props.macroCatB == 'Own Use' &&
			<g id="own-use">
				<polygon class="cls-1" points="12.5 18 14.51 21.95 19 22.58 15.75 25.66 16.52 30 12.5 27.95 8.48 30 9.25 25.66 6 22.58 10.49 21.95 12.5 18" />
			</g>
			}
			{ props.macroCatB == 'Development Projects' &&
			<g id="dev-pro">
				<polygon class="cls-1" points="12.5 18.74 15.75 24.37 19 30 12.5 30 6 30 9.25 24.37 12.5 18.74" />
			</g>
			}
			{ props.macroCatB == 'Direct Investments' &&
			<g id="direct-inv">
				<polygon class="cls-1" points="6.5 18.4 6.5 30.4 12.5 24.4 6.5 18.4" />
       			<polygon class="cls-1" points="18.5 18.4 12.5 24.4 18.5 30.4 18.5 18.4" />
			</g>
			}
			{ props.macroCatB == 'AuM for Pan EU Funds' &&
			<g id="aum-eu">
				<rect class="cls-1" x="7" y="19" width="11" height="11" />
			</g>
			}
			{ props.macroCatB == 'AuM for 3rd Parties' &&
			<g id="aum-third">
				<rect class="cls-1" x="7.9" y="19.4" width="9.19" height="9.19" transform="translate(20.63 -1.81) rotate(45)" />
			</g>
			}
			{ props.strategy == 'CORE' &&
			<g id="core">
				<path class="cls-1" d="M12.5,34A6.5,6.5,0,1,0,19,40.5,6.5,6.5,0,0,0,12.5,34Zm0,10.83a4.33,4.33,0,1,1,4.33-4.33A4.33,4.33,0,0,1,12.5,44.83Z" />
        		<circle class="cls-1" cx="12.5" cy="40.5" r="2" />
			</g>
			}
			{ props.strategy == 'Development' &&
			<g id="dev">
				<path class="cls-1" d="M17,40.23a4.5,4.5,0,0,1-3.5,4.38V34.9h-2v9.71A4.5,4.5,0,0,1,8,40.23H6a6.5,6.5,0,0,0,13,0Z" />
			</g>
			}
			{ props.strategy == 'Opportunistic' &&
			<g id="opport">
				<path class="cls-1" d="M19,44.11v-1a6.5,6.5,0,0,0-13,0v1Zm-6.5-5.5a4.5,4.5,0,0,1,4.39,3.5H8.11A4.5,4.5,0,0,1,12.5,38.61Z" />
			</g>
			}
			{ props.strategy == 'Trophy' &&
			<g id="trophy">
				<path class="cls-1" d="M6,34.81v1c0,.32,0,7.94,6,11.14l.48.25.47-.26c5.91-3.23,6-10.79,6-11.11v-1Zm10.91,2a13.44,13.44,0,0,1-.29,1.62H8.33a15.09,15.09,0,0,1-.27-1.62ZM12.48,44.9a9,9,0,0,1-3.54-4.47H16A9.24,9.24,0,0,1,12.48,44.9Z" />
			</g>
			}
			{ props.strategy == 'VALUE ADD' &&
			<g id="value-add">
				<path class="cls-1" d="M6,34V47H19V34Zm11,5.5H13.5V36H17ZM11.5,36v3.5H8V36ZM8,41.5h3.5V45H8ZM13.5,45V41.5H17V45Z" />
			</g>
			}
			{ props.saleStrategy == 'Hold' && props.macroCatC == 'CIELO TERRA' &&
			<g id="hold-ct" className={`color-${props._colorId || '01'}`}>
				<polygon points="1 12 12.5 4 12.5 1 1 9 1 12" />
			</g>
			}
			{ props.saleStrategy == 'Sell' && props.macroCatC == 'CIELO TERRA' &&
			<g id="sell-ct" className={`color-${props._colorId || '01'}`}>
				<polygon points="24 12 12.5 4 12.5 1 24 9 24 12" />
			</g>
			}
			{ props.saleStrategy == 'Hold' && props.macroCatC == 'PORZIONI' &&
			<g id="hold-porz" className={`color-${props._colorId || '01'}`}>
				<polygon points="1 1 12.5 9 12.5 12 1 4 1 1" />
			</g>
			}
			{ props.saleStrategy == 'Sell' && props.macroCatC == 'PORZIONI' &&
			<g id="sell-porz" className={`color-${props._colorId || '01'}`}>
				<polygon points="24 1 12.5 9 12.5 12 24 4 24 1" />

			</g>
			}
		</svg>
	);
}

function getMarkerIcon(data, stateStore){
	let index = -1;
	if (stateStore.colorGroup && data[stateStore.colorGroup] && stateStore.COLUMNS_AND_VALUES_MAP[stateStore.colorGroup]){
		let targetValue = data[stateStore.colorGroup];
		index = stateStore.COLUMNS_AND_VALUES_MAP[stateStore.colorGroup].findIndex( (item) => item.value == targetValue );
	}
	let svg = ReactDOMServer.renderToStaticMarkup(<CustomMarkerIcon {...data} _colorId={index != -1 ? String(index+1).padStart(2, '0') : null} />);
	return `data:image/svg+xml;utf-8,${encodeURIComponent(svg)}`;
}

export { getMarkerIcon };
